// Centralized membership tier definitions
// Fields: monthlyBonus, starCoinsBonus, ticketMultiplier, discountedEntryFees, redeemableRange, avatarDecoration
const memberships = {
  silver: {
    monthlyBonus: 500,
    starCoinsBonus: 500,
    ticketMultiplier: 1,
    discountedEntryFees: { casual: 250 },
    redeemableRange: { min: 5, max: 50 },
    avatarDecoration: "silver-ring",
  },
  gold: {
    monthlyBonus: 750,
    starCoinsBonus: 1200,
    ticketMultiplier: 2,
    discountedEntryFees: { casual: 250, standard: 500 },
    redeemableRange: { min: 5, max: 150 },
    avatarDecoration: "gold-ring",
  },
  platinum: {
    monthlyBonus: 2000,
    starCoinsBonus: 3000,
    ticketMultiplier: 2,
    discountedEntryFees: { casual: 250, standard: 500, highStakes: 900 },
    redeemableRange: { min: 5, max: 500 },
    avatarDecoration: "diamond-overlay",
  },
};

export default memberships;
